import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34; // 00:17:34

type CountdownTimerProps = {
  dark?: boolean;
};
export function CountdownTimer({
  dark = false
}: CountdownTimerProps) {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds(prev => prev <= 0 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  const units = [{
    label: 'Hours',
    value: h
  }, {
    label: 'Min',
    value: m
  }, {
    label: 'Sec',
    value: s
  }];
  return <div className="flex w-full max-w-md flex-col items-center gap-2" role="timer" aria-live="off" data-id="element-21" data-mp="15fh3q5bin1cy">
      <p className={`flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide sm:text-sm ${dark ? 'text-gold-300' : 'text-alert'}`} data-id="element-22" data-mp="34pyzo9w8td29">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-23" data-mp="1bzvs06ov08l9" />
        Promotional price ends in
      </p>
      <div className="flex items-center gap-2" data-id="element-24" data-mp="1h1cpds84xcx3">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-25" data-mp="123kcl7tz32ml" data-mpi={i}>
            <div className={`flex w-[72px] flex-col items-center rounded-xl py-2 sm:w-20 ${dark ? 'bg-white text-navy-950' : 'bg-navy-900 text-white'}`} data-id="element-26" data-mp="124lplhujtz6y">
              <span className="font-display text-2xl font-black tabular-nums sm:text-3xl" data-id="element-27" data-mp="1zq9k1x7g27fu">
                {String(u.value).padStart(2, '0')}
              </span>
              <span className={`text-[10px] font-semibold uppercase tracking-wider ${dark ? 'text-navy-700' : 'text-white/60'}`} data-id="element-28" data-mp="1l0tuulnkaa29">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`font-display text-2xl font-black ${dark ? 'text-white' : 'text-navy-900'}`} aria-hidden="true" data-id="element-29" data-mp="2iibw0v954zjr">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}